<template>
  <table class="table table-striped border-light">
    <thead>
    <tr>
      <th colspan="2">
        <h5 class="mb-0 text-center text-capitalize-first">
          {{ helper.trans('labels.external_transaction')}}
        </h5>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.tx_id') }}</th>
      <td>{{ transaction.txId }} <copy-button :value="transaction.txId"></copy-button></td>
    </tr>
    <tr v-if="transaction?.data.txNum">
      <th class="text-capitalize-first">{{ helper.trans('labels.tx_num') }}</th>
      <td>{{ transaction?.data.txNum }} <copy-button :value="transaction?.data.txNum"></copy-button></td>
    </tr>
    <tr v-if="transaction?.data.paymentSystemTransferNum">
      <th class="text-capitalize-first">{{ helper.trans('labels.paymentSystemTransferNum') }}</th>
      <td>{{ transaction?.data.paymentSystemTransferNum }} <copy-button :value="transaction?.data.paymentSystemTransferNum"></copy-button></td>
    </tr>
    <tr v-if="transaction?.data.sender">
      <th class="text-capitalize-first">{{ helper.trans('labels.sender') }}</th>
      <td>
        <ExternalNspkSender :value="transaction?.data.sender" />
      </td>
    </tr>
    <tr v-if="transaction?.data.raw">
      <th class="text-capitalize-first">{{ helper.trans('labels.sender') }}</th>
      <td>
        <pre>
          <code style="white-space: pre-line;">
              {{ transaction?.data.raw }}
          </code>
        </pre>
      </td>
    </tr>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.service') }}</th>
      <td>{{ transaction.service }}</td>
    </tr>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
      <td>{{ transaction.status }}</td>
    </tr>
    <tr>
      <th class="text-capitalize-first">{{ helper.trans('labels.date') }}</th>
      <td>
        {{ dateHelper.format(transaction.updatedAt) }}
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType, reactive, ref, toRefs} from 'vue'
import {helper} from "@/service/CommonHelper";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import ExternalNSPKTransactionDTO from "@/models/ExternalNSPKTransactionDTO";
import ExternalNspkSender from "@/components/ExternalNspkSender.vue";

export default defineComponent({
  components: {
    ExternalNspkSender,
    CopyButton,
  },
  props: {
    transaction: {
      type: Object as PropType<ExternalNSPKTransactionDTO>,
      required: true
    } as Prop<ExternalNSPKTransactionDTO>
  },
  setup(props) {

    return {
      dateHelper,
      numberFormatter,
      helper,
    }
  }
})
</script>
